export const resetCurrency = (state) => {
  state.currencies = [];
  state.status = '';
  state.lastUpdated = '';
};
